import { css } from '@emotion/react';
import { IonCol, IonGrid, IonRouterLink, IonRow, IonText } from '@ionic/react';
import React from 'react';
import * as commonCss from '../../styles/common';

const MapAttribution: React.FC = () => {
  const mapAttrCss = {
    container: [
      css({
        width: '140px',
        textAlign: 'center',
        padding: 0,
        margin: 0,
        'ion-col': {
          padding: 0,
        },
      }),
    ],
    text: [
      css({
        fontSize: '10px',
        textShadow: '-1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white,  1px 1px 0 white',
      }),
    ],
  };

  return (
    <IonGrid css={[mapAttrCss.container, commonCss.noPadding]}>
      <IonRow>
        <IonCol size="4">
          <IonRouterLink href="https://carto.com/platform" color="secondary" target="_blank">
            <IonText css={mapAttrCss.text}>© CARTO</IonText>
          </IonRouterLink>
        </IonCol>
        <IonCol size="8">
          <IonRouterLink href="https://www.openstreetmap.org/" color="secondary" target="_blank">
            <IonText css={mapAttrCss.text}>© OpenStreetMap</IonText>
          </IonRouterLink>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default MapAttribution;
